import config from "../config/Config"
import axios from 'axios';
import URLParams from '../config/URLParams'

let TAG = "[ServerHandler]."
class ServerHandler {

    getHeaders() {
        try {

            let agentId = localStorage.getItem('LOGIN_USER');

            let headers = {
                'agentid': "sunil@panterranetworks.com",
            };

            return headers;

        } catch (e) {

            console.log(TAG + 'Error in [getHeaders ]:: ' + e);
        }
    }

    getCookie(name) {

        let cookieValue = null;
        try {

            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }

            console.log(TAG + '[getCookie] cookieValue --- ' + cookieValue);
        } catch (e) {

            console.log(TAG + 'Error in [getCookie ]:: ' + e);
        }

        return cookieValue;
    }

    sendCSRFRequest() {

        try {

            console.log(TAG + 'sendCSRFRequest ------');

            let requstOptions = {

                headers: {
                    'Request-Origin': URLParams.APP_NAME,
                },
                //credentials: 'include',
            }

            let url = URLParams.SAMART_AI_SERVICE_URL + URLParams.REQ_CSRF_TOKEN

            fetch(url, requstOptions)
                .then(res => res.json())
                .then(data => {
                    const csrfToken = data.csrfToken;
                    localStorage.setItem("csrfToken", csrfToken);
                    console.log("csrfToken :: " + csrfToken)
                });

        } catch (e) {

            console.log(TAG + "ERROR: [sendCSRFRequest] ----- error :: " + e);
        }
    }

    async sendServerRequest(req_type, headersData, params, req_method, extra_data) {

        let self = this;
        try {

            let headersInfo = this.getHeaders();

            headersData = { ...headersInfo, ...headersData }

            let resp_status;
            let url = URLParams.SAMART_AI_SERVICE_URL + req_type

            console.log(TAG + "[sendServerRequest] ========== url :: " + url + " :: req_method :: " + req_method + " :: headersData :: " + JSON.stringify(headersData) + " :: extra_data :: " + JSON.stringify(extra_data));

            return new Promise((resolve, reject) => {

                try {

                    console.log(TAG + "[sendServerRequest] ====Promise====== ");

                    let csrfToken = localStorage.getItem("csrfToken")
                    let requstOptions = {

                        method: req_method,
                        headers: {
                            'Request-Origin': URLParams.APP_NAME,
                            'Content-Type': 'application/json',
                            'X-CSRFToken': csrfToken,
                        },
                        //credentials: 'include',
                    }

                    if (req_method == "POST") {

                        headersData = { ...params, ...headersData }
                        requstOptions.body = JSON.stringify(headersData)

                    } else {

                        params.headers = JSON.stringify(headersData)
                        url = self.setParams(url, params);
                    }

                    fetch(url, requstOptions).then(response => {

                        resp_status = response.status;
                        return response.json();

                    }).then((response_data) => {

                        response_data.resp_status = resp_status;

                        console.log(TAG + "[sendServerRequest] ====resp_status====== :: " + resp_status + " :: response_data.resp_status :: " + response_data.resp_status);

                        if (req_type === URLParams.REQ_ASK_QUESTION) {

                            let data = response_data.response_data;
                            resolve({ data, extra_data });

                        } else {

                            resolve({ response_data, extra_data });
                        }

                    }).catch(function (error) {

                        console.log(TAG + "Error in sendServerRequest :: " + error);
                        reject({ error, extra_data });
                    });

                } catch (e) {

                    console.log(TAG + 'Error in [sendServerRequest ]:: ' + e);
                    reject({ e, headersData });
                }
            });

        } catch (e) {

            console.log(TAG + 'Error in [sendServerRequest ]:: ' + e);
        }
    }


    async sendServerChatBotRequest(url, headersdata, params, req_method, extra_data) {
        let self = this;
        try {

            let headersData = {
                'Content-Type': 'application/json',
            }

            let headersInfo = this.getHeaders();

            headersData = { ...headersInfo, ...headersData }

            params.headers = JSON.stringify(headersData)

            let resp_status;

            return new Promise((resolve, reject) => {

                try {

                    let csrfToken = localStorage.getItem("csrfToken")

                    let requestOptions = {

                        method: 'POST',
                        headers: {
                            'Request-Origin': URLParams.APP_NAME,
                            'Content-Type': 'application/json',
                            'X-CSRFToken': csrfToken,
                        },
                        credentials: 'include',
                    }

                    if (req_method == "POST") {

                        requestOptions.body = JSON.stringify(headersData)
                    } else {

                        url = self.setParams(url, params);
                    }

                    console.log(TAG + "[sendServerChatBotRequest] -- url :: " + url)

                    fetch(url, requestOptions).then(response => {

                        resp_status = response.status;
                        return response.json();

                    }).then((response_data) => {

                        response_data.resp_status = resp_status;

                        console.log(TAG + "[sendServerChatBotRequest] ====resp_status====== :: " + resp_status + " :: response_data :: " + response_data);
                        resolve({ response_data, extra_data });

                    }).catch(function (error) {

                        console.log(TAG + "Error in sendServerChatBotRequest :: " + error);
                        reject({ error, params });
                    });

                } catch (e) {
                    console.log(TAG + '[sendServerChatBotRequest] Error 111 :: ' + e);
                }
            });

        } catch (error) {

            console.error(TAG + '[sendServerChatBotRequest] Error sending message:', error);
            return 'Sorry, something went wrong.';
        }
    }

    async uploadFileToServer(url, headersData, formData, extra_data) {

        let self = this;
        try {

            let headersInfo = this.getHeaders();

            let resp_status;

            console.log(TAG + "[uploadFileToServer] ========== url :: " + url + " :: headersData :: " + JSON.stringify(headersData) + " :: extra_data :: " + JSON.stringify(extra_data));

            let csrfToken = localStorage.getItem("csrfToken")
            let req_headers = {
                'Request-Origin': URLParams.APP_NAME,
                'X-CSRFToken': csrfToken,
                'Content-Type': 'multipart/form-data',
            }

            req_headers = { ...headersInfo, ...req_headers }

            return new Promise((resolve, reject) => {

                try {

                    console.log(TAG + "[uploadFileToServer] ====Promise====== ");

                    axios.post(url, formData, { headers: req_headers }).then(response => {

                        resp_status = response.status;
                        return response.data;

                    }).then((response_data) => {

                        response_data.resp_status = resp_status;

                        console.log(TAG + "[uploadFileToServer] ====resp_status====== :: " + resp_status + " :: response_data.resp_status :: " + response_data.resp_status);
                        resolve({ response_data, extra_data });

                    }).catch(function (error) {

                        console.log(TAG + "Error in uploadFileToServer :: " + error);
                        reject({ error, extra_data });
                    });

                } catch (e) {

                    console.log(TAG + 'Error in [uploadFileToServer ]:: ' + e);
                    reject({ e, headersData });
                }
            });

        } catch (error) {

            console.error(TAG + 'Error sending message:', error);
        }
    }

    setParams(url, params) {

        try {

            console.log(TAG + 'setParams ==== params :: ' + JSON.stringify(params));

            params = new URLSearchParams(params);
            url = `${url}?${params}`

        } catch (e) {

            console.log(TAG + 'Error in [setParams ]:: ' + e);
        }

        return url;
    }

}

let handlerInstance = Object.freeze(new ServerHandler());
export default handlerInstance; 